// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__E5LOH","textarea":"styles_textarea__1wDXB"};